var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImpressumIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.267.087c-.986 0-1.788.832-1.788 1.856v28.036c0 1.024.802 1.856 1.788 1.856h19.536c.985 0 1.787-.832 1.787-1.856v-7.96c-.084-.45 0-16.056 0-16.056a.63.63 0 0 0-.174-.437L22.351.268a.597.62 0 0 0-.423-.181zm.198 2.062H20.95v4.188c0 .423.33.766.737.766h3.917v4.744q.002 8.963.001 17.926H6.465z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.24 5.102h5.68a.743.743 0 0 0 .728-.756.74.74 0 0 0-.729-.755H9.24a.74.74 0 0 0-.728.755c0 .418.327.756.728.756m10.807 2.164a.743.743 0 0 0-.728-.756H9.268a.743.743 0 0 0-.728.756c0 .418.327.756.729.756h10.049a.74.74 0 0 0 .728-.756m-10.789 3.78h5.68a.74.74 0 0 0 .728-.756.743.743 0 0 0-.728-.756h-5.68a.743.743 0 0 0-.728.756c0 .418.326.756.728.756m14.725 5.246-15.869.049 7.797-4.308zm.03.188v1.125H8.155V16.48zm-.027 9.384v1.67H8.128v-1.67zM9.4 17.918h1.712v7.672H9.4zm3.919 0h1.712v7.672H13.32zm3.972 0h1.713v7.672H17.29zm3.92-.055h1.712v7.672H21.21z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpressumIcon);
export default __webpack_public_path__ + "static/media/Impressum_icon.d061612310e8eef27b667b960e75fd34.svg";
export { ForwardRef as ReactComponent };